<div class="flex flex-col space-y-4 mb-8">
  <!-- First Row -->
  <div class="flex justify-between items-center pb-4">
    <!-- Left content of the first row -->
    <ng-content select="ss-ng-header-title-row1-left"></ng-content>
    <!-- Right content of the first row -->
    <ng-content select="ss-ng-header-content-row1-right"></ng-content>
  </div>
  <!-- Second Row -->
  <div class="flex justify-between items-center pb-4">
    <!-- Left content of the second row -->
    <ng-content select="ss-ng-header-content-row2-left"></ng-content>
    <!-- Right content of the second row -->
    <ng-content select="ss-ng-header-content-row2-right"></ng-content>
  </div>
  <!-- Third Row -->
  @if (hasRow3) {
    <div class="flex justify-between items-center pb-4">
      <!-- Left content of the second row -->
      <ng-content select="ss-ng-header-content-row3-left"></ng-content>
      <!-- Right content of the second row -->
      <ng-content select="ss-ng-header-content-row3-right"></ng-content>
    </div>
  }

  <hr />
</div>
